import { Firmware, FirmwareQueryParam, FirmwareUploadParam } from '/@/types/device-firmware'
import request, { CommonListResponse, IListWorkspaceResponse, IPage, IWorkspaceResponse } from '/@/api/http/request'
import { Device } from '/@/types/device'
import { CURRENT_CONFIG } from '/@/api/http/config'

const HTTP_PREFIX = '/manage/api/v1'

// login
export interface LoginBody {
 username: string,
 password: string,
 flag: number,
}
export interface loginByToken {
  token: string,
}
export interface BindBody {
  device_sn: string,
  user_id: string,
  workspace_id: string,
  domain?: string
}
export interface HmsQueryBody {
  sns: string[],
  children_sn: string,
  device_sn: string,
  language: string,
  level: number | string,
  begin_time: number,
  end_time: number,
  message: string,
  domain: number,
}

// 定义删除航线算法模型的入参类型
export interface DeleteRouteAlgorithmModelParams {
  flyLineId: string;
  startPointIndex: number;
  endPointIndex: number;
}

export const exportDroneReportPackage = function (workspaceId:string, jobId:string) {
  return `${CURRENT_CONFIG.baseURL}${HTTP_PREFIX}/report/exportDroneReportPackage/${workspaceId}/${jobId}`
}
export const login = async function (body: LoginBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/login`
  const result = await request.post(url, body)
  return result.data
}
export const loginByToken = async function (body: loginByToken): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/loginByToken`
  const result = await request.post(url, body)
  return result.data
}

// Refresh Token
export const refreshToken = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/token/refresh`
  const result = await request.post(url, body)
  return result.data
}

// Get Platform Info
export const getPlatformInfo = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/current`
  const result = await request.get(url)
  return result.data
}

// Get User Info
export const getUserInfo = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/current`
  const result = await request.get(url)
  return result.data
}
// 添加用户账号
export const addUser = async function (data:{}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/addUser`
  const result = await request.post(url, data)
  return result.data
}
// 修改用户账号
export const updateUser = async function (data:{}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/updateUser`
  const result = await request.post(url, data)
  return result.data
}
// 删除用户账号
export const deleteUserById = async function (userId:number): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/deleteUserById/${userId}`
  const result = await request.get(url)
  return result.data
}
// 获取用户账号列表
export const getUserListPageVo = async function (data:{}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/getUserListPageVo`
  const result = await request.post(url, data)
  return result.data
}
// Get Device Topo
export const getDeviceTopo = async function (workspace_id: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices`
  const result = await request.get(url)
  return result.data
}

// Get Livestream Capacity
export const getLiveCapacity = async function (workspaceId:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/capacity/` + workspaceId
  const result = await request.get(url)
  return result.data
}

// Start Livestream
export const startLivestream = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/streams/start`
  const result = await request.post(url, body)
  return result.data
}

// Stop Livestream
export const stopLivestream = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/streams/stop`
  const result = await request.post(url, body)
  return result.data
}
// Update Quality
export const setLivestreamQuality = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/streams/update`
  const result = await request.post(url, body)
  return result.data
}

export const getAllUsersInfo = async function (wid: string, body: IPage): Promise<CommonListResponse<any>> {
  const url = `${HTTP_PREFIX}/users/${wid}/users?&page=${body.page}&page_size=${body.page_size}`
  const result = await request.get(url)
  return result.data
}

export const updateUserInfo = async function (wid: string, user_id: string, body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/${wid}/users/${user_id}`
  const result = await request.put(url, body)
  return result.data
}

export const bindDevice = async function (body: BindBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${body.device_sn}/binding`
  const result = await request.post(url, body)
  return result.data
}

export const unbindDevice = async function (device_sn: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${device_sn}/unbinding`
  const result = await request.delete(url)
  return result.data
}

export const getDeviceBySn = async function (workspace_id: string, device_sn: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/${device_sn}`
  const result = await request.get(url)
  return result.data
}

/**
 * 获取绑定设备信息
 * @param workspace_id
 * @param body
 * @param domain
 * @returns
 */
export const getBindingDevices = async function (workspace_id: string, body: IPage, domain: number): Promise<IListWorkspaceResponse<Device>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/bound?&page=${body.page}&page_size=${body.page_size}&domain=${domain}`
  const result = await request.get(url)
  return result.data
}

export const updateDevice = async function (body: {}, workspace_id: string, device_sn: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/${device_sn}`
  const result = await request.put(url, body)
  return result.data
}

export const getUnreadDeviceHms = async function (workspace_id: string, device_sn: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/hms/${device_sn}`
  const result = await request.get(url)
  return result.data
}

export const updateDeviceHms = async function (workspace_id: string, device_sn: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/hms/${device_sn}`
  const result = await request.put(url)
  return result.data
}

export const getDeviceHms = async function (body: HmsQueryBody, workspace_id: string, pagination: IPage): Promise<IListWorkspaceResponse<any>> {
  let url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/hms?page=${pagination.page}&page_size=${pagination.page_size}` +
    `&level=${body.level ?? ''}&begin_time=${body.begin_time ?? ''}&end_time=${body.end_time ?? ''}&message=${body.message ?? ''}&language=${body.language}`
  body.sns.forEach((sn: string) => {
    if (sn !== '') {
      url = url.concat(`&device_sn=${sn}`)
    }
  })
  const result = await request.get(url)
  return result.data
}

export const changeLivestreamLens = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/streams/switch`
  const result = await request.post(url, body)
  return result.data
}

export const getFirmwares = async function (workspace_id: string, page: IPage, body: FirmwareQueryParam): Promise<IListWorkspaceResponse<Firmware>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspace_id}/firmwares?page=${page.page}&page_size=${page.page_size}` +
    `&device_name=${body.device_name}&product_version=${body.product_version}&status=${body.firmware_status ?? ''}`
  const result = await request.get(url)
  return result.data
}

export const importFirmareFile = async function (workspaceId: string, param: FormData): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/firmwares/file/upload`
  const result = await request.post(url, param)
  return result.data
}

export const changeFirmareStatus = async function (workspaceId: string, firmwareId: string, param: {status: boolean}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/firmwares/${firmwareId}`
  const result = await request.put(url, param)
  return result.data
}
// 喊话器音量设置
export const volumeSet = async function (dockSn: string, param: {psdk_index: number, play_volume:number}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${dockSn}/volumeSet`
  const result = await request.post(url, param)
  return result.data
}
// 喊话器tts喊话
export const ttsPlayStart = async function (dockSn: string, param: {
  psdk_index: number,
  tts: {
    name: string,
    text: string,
    md5: string
  }
}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${dockSn}/ttsPlayStart`
  const result = await request.post(url, param)
  return result.data
}
// 喊话器停止播放
export const stopPlay = async function (dockSn: string, param: {psdk_index: number}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${dockSn}/stopPlay`
  const result = await request.post(url, param)
  return result.data
}
// 喊话器重复播放
export const replay = async function (dockSn: string, param: {psdk_index: number}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${dockSn}/replay`
  const result = await request.post(url, param)
  return result.data
}
// 喊话器播放模式playMode,0,1
export const playModeSet = async function (dockSn: string, param: {psdk_index: number, play_mode:number}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${dockSn}/playModeSet`
  const result = await request.post(url, param)
  return result.data
}
// 喊话器输入框播放
export const inputBoxTextSet = async function (dockSn: string, param: {psdk_index: number, value:string}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${dockSn}/inputBoxTextSet`
  const result = await request.post(url, param)
  return result.data
}
// 喊话器录音播放
export const audioPlayStart = async function (dockSn: string, param: {psdk_index: number, file: {
  name: string,
  url: string,
  md5: string,
  format: string// 默认pcm
}}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${dockSn}/audioPlayStart`
  const result = await request.post(url, param)
  return result.data
}
// 喊话器上传pcm文件
export const importPcmFile = async function (formData: FormData): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/pcmFile/upload`
  const result = await request.post(url, formData)
  return result.data
}
export const getPcmHistory = async function (workspace_id:string, page:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${workspace_id}/getPcmHistory`
  const result = await request.post(url, page)
  return result.data
}
// 喊话列表
export const getAudioFileList = async function (workspace_id:string, page:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/${workspace_id}/files?page=${page.page}&page_size=${page.page_size}`
  const result = await request.get(url)
  return result.data
}
// 喊话列表删除
export const deleteAudioFileList = async function (audio_id:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/deleteById/${audio_id}`
  const result = await request.get(url)
  return result.data
}
// tts文本列表
export const getPsdkTextList = async function (workspace_id:string, page:IPage): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/${workspace_id}/getPsdkTextList?page=${page.page}&page_size=${page.page_size}`
  const result = await request.get(url)
  return result.data
}
export const saveTtsContent = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/saveTtsContent`
  const result = await request.post(url, body)
  return result.data
}
export const getTtsContentListPage = async function (body:object, workspaceId:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/getTtsContentListPage/${workspaceId}`
  const result = await request.post(url, body)
  return result.data
}
export const deleteTtsContent = async function (id:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/deleteTtsContent/${id}`
  const result = await request.post(url)
  return result.data
}
// 灯光状态改变
export const widgetValueSet = async function (dockSn: string, param:{
  psdk_index: number,
  index:number,
  value:number
}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/speaker/psdk/${dockSn}/widgetValueSet`
  const result = await request.post(url, param)
  return result.data
}
// 获取指点飞行文件列表
export const getFlightIdList = async function (workspace_id:string, page:IPage): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/takeToPoint/${workspace_id}/getFlightIdList?page=${page.page}&page_size=${page.page_size}&sn=${page.sn}`
  const result = await request.get(url)
  return result.data
}
// 获取首页信息
export const getIndexData = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/index/getIndexData`
  const result = await request.get(url)
  return result.data
}
// 获取统计信息
export const getStatisticsData = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/index/indexData`
  const result = await request.get(url)
  return result.data
}
// 获取告警信息列表
export const getAlarmDataListPageVo = async function (param:{
  page_num:number,
  page_size:number,
  region_code?:number,
  workspace_id:string,
  marker_status:number
}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/alarmData/getAlarmDataListPageVo`
  const result = await request.post(url, param)
  return result.data
}
// 获取所有算法模型列表
export const getAlgorithmModelListPageVo = async function (param: {
  page: number
  size: number
  name: string
}): Promise<IWorkspaceResponse<any>> {
  const url = '/model/list'
  const result = await request.post(url, param)
  return result.data
}

// 获取航线的算法模型
export const getRouteAlgorithmModel = async function (routeId:string): Promise<IWorkspaceResponse<any>> {
  const url = `/sk2/getWaypointBoundAlgorithmModels/${routeId}`
  const result = await request.get(url)
  return result.data
}

// 删除航线算法模型
export const deleteRouteAlgorithmModel = async function (
  params: DeleteRouteAlgorithmModelParams
): Promise<IWorkspaceResponse<any>> {
  const url = '/wayline/api/v1/workspaces/waylines/delFlyAlgorithmModelByRange'
  const result = await request.post(url, params)
  return result.data
}

// 上传算法模型
export const uploadModel = async function (formData: FormData): Promise<IWorkspaceResponse<any>> {
  const url = '/model/upload'
  const result = await request.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return result.data
}
// 删除算法模型
export const deleteModel = async function (params: { id: string | number }): Promise<IWorkspaceResponse<any>> {
  const url = '/model/delete'
  const result = await request.get(url, { params })
  return result.data
}
// 部署大模型
export interface DeployModelParams {
  id: string | number
  model_name: string
  model_path: string
}
export const deployModel = async function (params: DeployModelParams): Promise<IWorkspaceResponse<any>> {
  const url = '/model/deploy'
  const result = await request.post(url, params)
  return result.data
}
// 修改算法模型
export interface UpdateModelParams {
  id: string | number
  name: string
  type: string
  label: string
  version: string
  status: string
}

export const updateModel = async function (
  params: UpdateModelParams
): Promise<IWorkspaceResponse<any>> {
  const url = '/model/update'
  const result = await request.post(url, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
  return result.data
}

// 删除容器（部署实例）
export interface DeleteContainerParams {
  model_name: string
  model_id: string | number
  id: string | number
}
export const deleteContainer = async function (params: DeleteContainerParams): Promise<IWorkspaceResponse<any>> {
  const url = '/model/delete'
  const result = await request.post(url, params)
  return result.data
}
// 停止容器
export interface StopContainerParams {
  model_name: string
  id: string | number
}
export const stopContainer = async function (params: StopContainerParams): Promise<IWorkspaceResponse<any>> {
  const url = '/model/stop'
  const result = await request.post(url, params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
  return result.data
}

// 获取算法类型
export const getAiTypeDataDict = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/ai/getAiTypeDataDict`
  const result = await request.get(url)
  return result.data
}
export const getAlarmId = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/alarmData/getAlarmId`
  const result = await request.post(url, body)
  return result.data
}
export const toCheckPoint = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/alarmData/toCheckPoint`
  const result = await request.post(url, body)
  return result.data
}
export const personFaceLibPage = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/personFaceLibPage`
  const result = await request.post(url, body)
  return result.data
}
export const personFaceLibAdd = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/personFaceLibAdd`
  const result = await request.post(url, body)
  return result.data
}
export const personFaceLibUpdate = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/personFaceLibUpdate`
  const result = await request.post(url, body)
  return result.data
}
export const plateLibUpdate = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/plateLibUpdate`
  const result = await request.post(url, body)
  return result.data
}
export const personFaceLibBatchDelete = async function (data:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/personFaceLibBatchDelete`
  const result = await request.post(url, data)
  return result.data
}
export const plateLibPage = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/plateLibPage`
  const result = await request.post(url, body)
  return result.data
}
export const plateLibAdd = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/plateLibAdd`
  const result = await request.post(url, body)
  return result.data
}
export const plateLibBatchDelete = async function (data:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/plateLibBatchDelete`
  const result = await request.post(url, data)
  return result.data
}
export const faceCompareRecordPage = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/faceCompareRecordPage`
  const result = await request.post(url, body)
  return result.data
}
export const carCompareRecordPage = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/carCompareRecordPage`
  const result = await request.post(url, body)
  return result.data
}
export const cameraPage = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/cameraPage`
  const result = await request.post(url, body)
  return result.data
}
export const addCamera = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/addCamera`
  const result = await request.post(url, body)
  return result.data
}
export const deleteCamera = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/deleteCamera`
  const result = await request.post(url, body)
  return result.data
}
export const updateCamera = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/baseInfo/updateCamera`
  const result = await request.post(url, body)
  return result.data
}
export const uploadFace = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = '/upload_face'
  const result = await request.post(url, body, {
    baseURL: '/infer/'
  })
  return result.data
}
export const deleteFace = async function (body: object): Promise<IWorkspaceResponse<any>> {
  const url = '/delete_face'
  const formData = new FormData()
  formData.append('json', JSON.stringify(body))

  const result = await request.post(url, formData, {
    baseURL: '/infer/',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return result.data
}
export const deletePlate = async function (body: object): Promise<IWorkspaceResponse<any>> {
  const url = '/delete_plate'
  const formData = new FormData()
  formData.append('json', JSON.stringify(body))

  const result = await request.post(url, formData, {
    baseURL: '/infer/',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return result.data
}
export const uploadPlate = async function (body:object): Promise<IWorkspaceResponse<any>> {
  const url = '/upload_plate'
  const result = await request.post(url, body, {
    baseURL: '/infer/'
  })
  return result.data
}
export const getPerson = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/get_person'
  const result = await request.get(url, {
    baseURL: '/infer/'
  })
  return result.data
}
export const ctrlDrone = async function (query: object): Promise<IWorkspaceResponse<any>> {
  const url = '/ctrl_drone'
  const formData = new FormData()
  // 注意这里要转成字符串
  formData.append('json', JSON.stringify(query))
  const result = await request.post(url, formData, {
    baseURL: '/infer/',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return result.data
}
export const getPlate = async function (): Promise<IWorkspaceResponse<any>> {
  const url = '/get_plate'
  const result = await request.get(url, {
    baseURL: '/infer/'
  })
  return result.data
}
export const getSnap = async function (query: object): Promise<IWorkspaceResponse<any>> {
  const url = '/get_snap'
  const formData = new FormData()
  // 注意这里要转成字符串
  formData.append('json', JSON.stringify(query))
  const result = await request.post(url, formData, {
    baseURL: '/infer/',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return result.data
}
// 新绑定算法
export const bindingAiAlgorithm = async function (body:{}): Promise<IWorkspaceResponse<{}>> {
  const url = `${HTTP_PREFIX}/ai/bindingAiAlgorithm`
  const result = await request.post(url, body)
  return result.data
}
// 获取新绑定算法
export const getWayLineAiBindingDetail = async function (body:{}): Promise<IWorkspaceResponse<{}>> {
  const url = `${HTTP_PREFIX}/ai/getWayLineAiBindingDetail`
  const result = await request.post(url, body)
  return result.data
}
// 获取推送日志列表
export const getHttpPushLogListPageVo = async function (body:{}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/httpPushLog/getHttpPushLogListPageVo`
  const result = await request.post(url, body)
  return result.data
}
// 通过选择的两个飞行任务id对比相同图片的差异
export const diffImageByJobIds = async function (data: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/ai/diffImageByJobIds`
  const result = await request.post(url, data)
  return result.data
}
// 通过航线id查询飞行任务媒体数一致的数据
export const getFlyJobMediaCountSameByWayLineId = async function (wayLineId:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/ai/getFlyJobMediaCountSameByWayLineId?wayLineId=${wayLineId}`
  const result = await request.get(url)
  return result.data
}
// 查询对比过的数据
export const getDiffImageListPageVo = async function (body:{}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/ai/getDiffImageListPageVo`
  const result = await request.post(url, body)
  return result.data
}
// 删除图片对比数据
export const deleteDiffImageById = async function (body:{}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/ai/deleteDiffImageById`
  const result = await request.post(url, body)
  return result.data
}
// 航线绑定文件对比，是否开启
export const addWayLineFileDiffData = async function (body:{}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/wayLineFileDiffData/addWayLineFileDiffData`
  const result = await request.post(url, body)
  return result.data
}

// 获取航线绑定文件对比详情
export const getWayLineFileDiffDataById = async function (wayLineId:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/wayLineFileDiffData/getWayLineFileDiffDataByWayLineId/${wayLineId}`
  const result = await request.get(url)
  return result.data
}
// 删除航线绑定对比信息
export const deleteWayLineFileDiffDataById = async function (id:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/wayLineFileDiffData/deleteWayLineFileDiffDataById/${id}`
  const result = await request.get(url)
  return result.data
}
